var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.8125C11.3162 15.8125 11.1322 15.7423 10.9919 15.602L3.80439 8.41445C3.52354 8.1336 3.52354 7.67881 3.80439 7.39814C4.08524 7.11747 4.54003 7.11729 4.8207 7.39814L11.5 14.0775L18.1794 7.39814C18.4602 7.11729 18.915 7.11729 19.1957 7.39814C19.4764 7.67899 19.4766 8.13378 19.1957 8.41445L12.0082 15.602C11.8679 15.7423 11.6839 15.8125 11.5 15.8125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown2);
export default __webpack_public_path__ + "static/media/chevron-down-2.448594ec6902ae051c2b16eb0d467b2e.svg";
export { ForwardRef as ReactComponent };